"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styled_components_1 = require("styled-components");

var Context_1 = require("./Context");

var template_1 = require("./template");

var Scheme_1 = require("react-sidenav/types/Scheme");

var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"])));

var SideNav =
/** @class */
function (_super) {
  __extends(SideNav, _super);

  function SideNav(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      selectedPath: undefined,
      defaultSelectedPath: undefined
    };

    _this.onItemSelection = function (arg) {
      if (_this.state.selectedPath) {
        _this.setState({
          selectedPath: arg.path
        }, function () {
          _this.dispatchItemSelection(arg);
        });
      } else {
        _this.dispatchItemSelection(arg);
      }
    };

    _this.dispatchItemSelection = function (arg) {
      if (_this.props.onItemSelection) {
        _this.props.onItemSelection(arg);
      }
    };

    if (_this.props.defaultSelectedPath) {
      _this.state = {
        selectedPath: _this.props.defaultSelectedPath,
        defaultSelectedPath: _this.props.defaultSelectedPath
      };
    }

    return _this;
  }

  SideNav.prototype.render = function () {
    var selectedPath = this.state.defaultSelectedPath !== undefined ? this.state.selectedPath : this.props.selectedPath;

    var propsTemplate = __assign({}, this.props.template);

    var template = __assign({
      item: template_1.template.item,
      children: template_1.template.children
    }, propsTemplate);

    var theme = this.props.theme || {};
    var scheme = this.props.scheme || Scheme_1.Scheme.default;
    var value = {
      selectedPath: selectedPath,
      onItemSelection: this.onItemSelection,
      template: template,
      theme: theme,
      scheme: scheme,
      expandOnHover: this.props.expandOnHover || false
    };
    return React.createElement(Context_1.Provider, {
      value: value
    }, React.createElement(Container, null, this.props.children));
  };

  return SideNav;
}(React.Component);

exports.SideNav = SideNav;
var templateObject_1;